/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Merge_UpInputs */



/**
* | output |
* | --- |
* | "Merge the selected Event with the previous Event." |
*
* @param {Shortcut_Keys_Desc_Merge_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_merge_up = /** @type {((inputs?: Shortcut_Keys_Desc_Merge_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Merge_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner l'evenement selectionne avec l'evenement precedent.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das ausgewählte Ereignis wird mit dem vorherigen Ereignis zusammengeführt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci l'evento selezionato con l'evento precedente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединить выбранное событие с предыдущим событием.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar el evento seleccionado con el evento anterior.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定的事件与之前的事件合并。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを前のイベントと結合します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट को पिछले इवेंट के साथ मर्ज करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mesclar o evento selecionado com o evento anterior.")
	return /** @type {LocalizedString} */ ("Merge the selected Event with the previous Event.")
});